import { createCleanup, createReaction } from "fluidstate";
import { LocationActions } from "./location-actions";

declare const IS_SERVER: boolean;

export const createLocationReactions = (locationActions: LocationActions) => {
	return [
		createReaction(() => {
			if (IS_SERVER) {
				return;
			}

			window.addEventListener("popstate", locationActions.onLocationChange);

			createCleanup(() => {
				window.removeEventListener(
					"popstate",
					locationActions.onLocationChange
				);
			});
		}),
	];
};
